import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class BatchBillingServiceContractsResultItem<
  T extends EMode = EMode.entity
> {
  /** Alias: contractCode */
  contractCode?: any;
  /** Alias: invoiceCode */
  invoiceCode?: any;
  /** Alias: success */
  success?: any;
  /** Alias: message */
  message?: any;

  __typename?: string;
}

const fields: FieldDefinitions<BatchBillingServiceContractsResultItem> = {
  contractCode: {
    alias: 'contractCode',
  },
  invoiceCode: {
    alias: 'invoiceCode',
  },
  success: {
    alias: 'success',
  },
  message: {
    alias: 'message',
  },
  __typename: {
    alias: '__typename',
  },
};

export const batchBillingServiceContractsResultItemEntityDefinition: EntitiyDefinition<BatchBillingServiceContractsResultItem> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'BatchBillingServiceContractsResultItem',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
